import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ColumnDataType, ConfigurationColumn } from 'src/app/shared/model/resource';
import { ClientesService } from 'src/app/shared/api/clientes.service';
import { formatarCNPJ } from 'src/app/shared/functions/format-functions';
import { AdmEquipeService, ICliente } from 'src/app/shared/api/adm-equipe.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { ETipoAcesso } from 'src/app/app-navigation';
import { EquipeService } from 'src/app/shared/api/equipe.service';

@Component({
    selector: 'filtros-dashboard',
    templateUrl: './filtros-dashboard.component.html',
    styleUrls: ['./filtros-dashboard.component.scss']
})
export class FiltrosDashboardComponent implements OnInit {
    tipoAcesso!: ETipoAcesso;
    TIPO_ACESSO_ADM = ETipoAcesso.ADMINISTRADOR;

    valorFiltro: any = {
        filtroCliente: {},
        filtroEquipe: {},
        filtroIniciado: {},
        filtroConcluido: {}
    };

    colunasClientes!: ConfigurationColumn[];
    colunasEquipes!: ConfigurationColumn[];

    colunasIniciadoEntre!: ConfigurationColumn[];
    colunasConcluidoEntre!: ConfigurationColumn[];

    @Output() filtroChange = new EventEmitter();

    constructor(
        private admEquipeService: AdmEquipeService,
        private equipeService: EquipeService,
        private authService: AuthService
    ) {}

    ngOnInit(): void {
        this.tipoAcesso = this.authService.getTipoAcesso();
        this.criarColunasFiltros();
        this.criarColunaEquipes();
    }

    private criarColunasFiltros() {
        this.colunasClientes = [
            {
                field: 'cliente',
                label: 'Cliente',
                sizeColumn: 'col-12',
                type: ColumnDataType.Lookup,
                lookupConfiguration: {
                    fieldName: 'nome_fantasia',
                    fieldPk: 'uuid',
                    colunas: [
                        { field: 'nome_fantasia', label: 'Nome Fantasia' },
                        { field: 'cnpj', label: 'CNPJ', calculateDisplayValue: formatarCNPJ }
                    ],
                    service: ClientesService
                }
            }
        ];

        this.colunasIniciadoEntre = [
            {
                field: 'iniciadoDe',
                label: 'De',
                sizeColumn: 'col-md-6',
                type: ColumnDataType.Date
            },
            {
                field: 'iniciadoAte',
                label: 'Até',
                sizeColumn: 'col-md-6',
                type: ColumnDataType.Date
            }
        ];

        this.colunasConcluidoEntre = [
            {
                field: 'concluidoDe',
                label: 'De',
                sizeColumn: 'col-md-6',
                type: ColumnDataType.Date
            },
            {
                field: 'concluidoAte',
                label: 'Até',
                sizeColumn: 'col-md-6',
                type: ColumnDataType.Date
            }
        ];
    }

    private criarColunaEquipes() {
        if (
            this.tipoAcesso == ETipoAcesso.ADMINISTRADOR &&
            !this.valorFiltro.filtroCliente?.cliente?.uuid
        ) {
            return;
        }

        const service = this.getEquipeServiceAcesso();

        this.colunasEquipes = [
            {
                field: 'equipe',
                label: 'Equipe',
                sizeColumn: 'col-12',
                type: ColumnDataType.Lookup,
                lookupConfiguration: {
                    fieldName: 'nome',
                    fieldPk: 'uuid',
                    colunas: [{ field: 'nome', label: 'Nome' }],
                    instanciaService: service
                }
            }
        ];
    }

    private getEquipeServiceAcesso() {
        if (this.tipoAcesso == ETipoAcesso.ADMINISTRADOR) {
            this.admEquipeService.setBaseUrl(this.valorFiltro.filtroCliente.cliente.uuid);
            return this.admEquipeService;
        }
        return this.equipeService;
    }

    changeCliente(cliente: ICliente) {
        this.criarColunaEquipes();
        this.changeFormulario();
    }

    changeFormulario() {
        this.filtroChange.emit(this.valorFiltro);
    }
}
